// Meeting timestamps are stored as UTC and ALWAYS displayed in Maldives time
// (MVT) for every viewer — a meeting time is an official, location-fixed time,
// not the viewer's local time. Rendering in the device's local zone made a VP on
// a non-MVT device see a meeting shifted by hours. MVT is a fixed UTC+5 with no
// DST, so we shift the instant by +5h and read its UTC wall-clock (equivalent to
// formatting in Indian/Maldives, without pulling in Intl timezone data).
const MVT_OFFSET_MS = 5 * 60 * 60 * 1000;
function mvt(iso: string): Date {
  return new Date(new Date(iso).getTime() + MVT_OFFSET_MS);
}

const DV_WEEKDAYS = ['އާދީއްތަ', 'ހޯމަ', 'އަންގާރަ', 'ބުދަ', 'ބުރާސްފަތި', 'ހުކުރު', 'ހޮނިހިރު'];
const DV_MONTHS = ['ޖެނުއަރީ', 'ފެބްރުއަރީ', 'މާރިޗު', 'އޭޕްރީލް', 'މޭ', 'ޖޫން', 'ޖުލައި', 'އޮގަސްޓު', 'ސެޕްޓެންބަރު', 'އޮކްޓޫބަރު', 'ނޮވެންބަރު', 'ޑިސެންބަރު'];

export function formatDvDate(iso: string): string {
  const d = mvt(iso);
  return `${DV_WEEKDAYS[d.getUTCDay()]}، ${d.getUTCDate()} ${DV_MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

// Same as formatDvDate but without the weekday prefix (e.g. statistics pages
// where only the date is wanted).
export function formatDvDateShort(iso: string): string {
  const d = mvt(iso);
  return `${d.getUTCDate()} ${DV_MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

export function formatDvTime(iso: string): string {
  const d = mvt(iso);
  return `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`;
}

export function meetingNumber(year: number, sequence: number): string {
  return `${year}/${sequence}`;
}

// Date-only round-trip for <input type="date">, which always speaks
// YYYY-MM-DD in the viewer's local calendar. A letter date is an MVT
// calendar date (not viewer-local — same "a fixed date, not a local
// instant" reasoning as meeting times above), so read/write it through the
// MVT-shifted wall clock rather than the browser's local timezone.
export function isoToMvtDateInput(iso: string): string {
  const d = mvt(iso);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// Inverse: an <input type="date"> value (YYYY-MM-DD, no time) back into an
// ISO instant the backend's z.coerce.date() can parse, anchored at MVT
// midnight so the date doesn't shift a day depending on server-local tz.
export function mvtDateInputToIso(dateInput: string): string {
  return `${dateInput}T00:00:00+05:00`;
}
